import { DeleteIcon, ViewDocumentIcon } from 'Assets/icons'
import { CommonToolTip, CstmPagination } from 'components/Common/Common'
import AddReceiptsModal from 'components/Modals/AddReceiptsPop'
import ConfirmationPop from 'components/Modals/ConfirmationPop'
import ErrorComponent from 'components/shared/ErrorComponent'
import TableHeader from 'components/shared/FormComponents/TableHeader'
import LoadingIndicator from 'components/shared/LoadingIndicator'
import LoadingOverlay from 'components/shared/LoadingOverlay'
import TableLayout from 'components/TableLayout'
import { CLIENT_ASSIGNED_COSNENT_FORMS_VIEW } from 'config/paths'
import { successMessageToast } from 'helpers/common'
import ViewAttachments from 'pages/SideTabPages/ManageSupportStaff/TaskSessionView/ViewAttachments'
import React, { useState } from 'react'
import { Button, Row } from 'react-bootstrap'
import { Link, useParams } from 'react-router-dom'
import { useDeleteGuadianDocumentMutation, useGetGuardianClientDocumentsQuery } from 'store/services/guardian'
import { useLazyGetFileUrlQuery } from 'store/services/utility'

export const ManageDocuemnts = () => {
    const { id, parentId } = useParams()
    const pageSize = 10
    const [currentPage, setCurrentPage] = useState(1)
    const [filter, setFilter] = useState({ search: "", })
    const [modalType, setModalType] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [currentEntry, setCurrentEntry] = useState(null);
    const [receiptsModal, setReceiptsModal] = useState(false)

    const { data, isLoading, isFetching, isError } = useGetGuardianClientDocumentsQuery({ id, parentId, page: currentPage, limit: pageSize, ...filter });
    // const { data: attachments, isLoading: attachmentsLoading } = useGetGuardianClientDocumentsQuery({ id, parentId })

    const totalRecords = data?.totalRecords || 0;
    const totalPages = Math.ceil(totalRecords / pageSize);
    const [getFileUrl, { isLoading: getFileLoading, isFetching: getFileFetching }] = useLazyGetFileUrlQuery();
    const [deleteDocument, { isLoading: deleteDocumentLoading }] = useDeleteGuadianDocumentMutation()

    const column = [
        {
            head: "Name",
            accessor: "attachment_name",
            isComponent: true,
            // sorter: true,
            component: (item, ind) => (
                <h6 className="m-0 fw-bold themeBlue">{item?.attachment_name || "--"}</h6>
            ),
        },
        {
            head: "Action",
            accessor: "",
            isComponent: true,
            component: (item) => (
                <div className="ActnBtn d-flex align-items-center  gap-10">
                    {/* <CommonToolTip
                text={"Checlist"}
                component={<Button
                  className="p-0"
                  variant="transparent"
                  type="button"
                  onClick={() => { setCurrentEntry(item); setCheckListModal(true) }}
                >
                  <CheckIcon />
                </Button>}
              /> */}
                    <CommonToolTip
                        text={"Delete"}
                        component={<Button
                            className="p-0"
                            variant="transparent"
                            type="button"
                            onClick={() => {

                                setCurrentEntry(item);
                                setModalType("delete");
                                setShowModal(true);
                            }}
                        >
                            <DeleteIcon />
                        </Button>}
                    />
                    <CommonToolTip
                        text={"View"}
                        component={<Button
                            onClick={() => handleViewPdf(item?.attachment_key)}
                            className="p-0"
                            variant="transparent"
                            type="button"
                        >
                            <ViewDocumentIcon />
                        </Button>}
                    />
                </div>
            ),
        },
    ]

    const resetFilter = () => {
        setFilter({ search: "", appointment_type: "", status: "active" });
        setCurrentPage(1)
    };

    const handleFilterChange = (key) => (value) => {
        setFilter({ ...filter, [key]: value })
        setCurrentPage(1); // Reset to first page when filter changes
    };

    const handlePageChange = (page) => {
        window.scrollTo(0, 0);
        setCurrentPage(page);
    };
    console.log('currentEntry', currentPage)
    const handleDeleteAppointment = async () => {
        try {

            setShowModal(false);

            // const list = [...therapistProfiles];
            // const index = therapistProfiles?.findIndex(x => x.id === currentEntry?.id);
            // delete list[index];
            // setTherapistProfiles(list.filter(Boolean));

            const response = await deleteDocument({ id: currentEntry?.id }).unwrap();
            console.log('result response', response)
            successMessageToast(response?.message);

        } catch (err) {
            console.log("error deleting appointment", err);
        }
    };

    const handleViewPdf = async (name) => {

        try {
            const url = await getFileUrl(name).unwrap();
            if (url) window.open(url, '_blank');

        } catch (err) { console.error("Error assigning therapist", err); }
    };


    return (

        <>
            <AddReceiptsModal show={receiptsModal} setShow={setReceiptsModal} />
            <ConfirmationPop
                confirmation={showModal}
                setConfirmation={setShowModal}
                confirmHandler={modalType == "delete" ? handleDeleteAppointment : handleDeleteAppointment}
                type={modalType}
            />
            <div className="TableFilter d-flex align-items-end justify-content-between gap-10  ">
                <div className="left">
                    <TableHeader
                        heading={"Documents"}
                        hideStatusFilter
                        handleFilterChange={handleFilterChange}
                        resetFilter={resetFilter}
                        filter={filter}
                        searchPlaceholder="Document name"
                    >
                    </TableHeader>
                </div>
                <div className="right">
                    <ul style={{ marginBottom: "13px" }} className="list-unstyled ps-0 d-flex align-items-center justify-content-center flex-wrap gap-10">
                        {/* <li className="">
                            <Link
                                // to={MANAGE_STATUS_ADD}
                                onClick={() => setReceiptsModal(true)}
                                className="btn text-white d-flex align-items-center justify-content-center commonBtn fw-sbold "
                            >
                                <span className="icn me-1">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="19"
                                        height="19"
                                        viewBox="0 0 19 19"
                                        fill="none"
                                    >
                                        <mask
                                            id="mask0_0_4440"
                                            style={{ maskType: "alpha" }}
                                            maskUnits="userSpaceOnUse"
                                            x="0"
                                            y="0"
                                            width="19"
                                            height="19"
                                        >
                                            <rect
                                                width="18.7197"
                                                height="18.7197"
                                                fill="#D9D9D9"
                                            />
                                        </mask>
                                        <g mask="url(#mask0_0_4440)">
                                            <path
                                                d="M8.57996 13.2594H10.1399V10.1394H13.2599V8.57947H10.1399V5.45951H8.57996V8.57947H5.46V10.1394H8.57996V13.2594ZM9.35995 17.1593C8.28096 17.1593 7.26698 16.9546 6.31799 16.5451C5.369 16.1356 4.54352 15.5799 3.84153 14.8779C3.13954 14.1759 2.58379 13.3504 2.1743 12.4014C1.76481 11.4524 1.56006 10.4384 1.56006 9.35946C1.56006 8.28047 1.76481 7.26649 2.1743 6.3175C2.58379 5.36851 3.13954 4.54303 3.84153 3.84104C4.54352 3.13905 5.369 2.58331 6.31799 2.17381C7.26698 1.76432 8.28096 1.55957 9.35995 1.55957C10.4389 1.55957 11.4529 1.76432 12.4019 2.17381C13.3509 2.58331 14.1764 3.13905 14.8784 3.84104C15.5804 4.54303 16.1361 5.36851 16.5456 6.3175C16.9551 7.26649 17.1598 8.28047 17.1598 9.35946C17.1598 10.4384 16.9551 11.4524 16.5456 12.4014C16.1361 13.3504 15.5804 14.1759 14.8784 14.8779C14.1764 15.5799 13.3509 16.1356 12.4019 16.5451C11.4529 16.9546 10.4389 17.1593 9.35995 17.1593ZM9.35995 15.5994C11.1019 15.5994 12.5774 14.9949 13.7864 13.7859C14.9954 12.5769 15.5999 11.1014 15.5999 9.35946C15.5999 7.61748 14.9954 6.142 13.7864 4.93302C12.5774 3.72404 11.1019 3.11955 9.35995 3.11955C7.61797 3.11955 6.14249 3.72404 4.93351 4.93302C3.72453 6.142 3.12004 7.61748 3.12004 9.35946C3.12004 11.1014 3.72453 12.5769 4.93351 13.7859C6.14249 14.9949 7.61797 15.5994 9.35995 15.5994Z"
                                                fill="white"
                                            />
                                        </g>
                                    </svg>
                                </span>{" "}
                                Add Receipt
                            </Link>
                        </li> */}
                    </ul>
                </div>
            </div>
            <div className="table-outer">
                {isLoading ? (
                    <div style={{ height: "200px" }}>
                        <LoadingIndicator />
                    </div>
                ) : isError ? (
                    <ErrorComponent />
                ) : (
                    <>
                        {(isFetching || deleteDocumentLoading || getFileLoading) && (
                            <LoadingOverlay />
                        )}
                        <TableLayout data={data?.records} column={column} />
                    </>
                )}
                <CstmPagination
                    totalPages={totalPages}
                    activePage={currentPage}
                    handlePageChange={handlePageChange}
                />
            </div>
        </>


    )
}
